import React, { Component } from "react";
import StandardTableAH from "views/Pma/PmaEditor/ThirdPageComponents/StandardTableAH";
import "views/Pma/PmaEditor/CommonEditor/ivyprestoFonts.scss";

class ThirdPageComponents extends Component {
  render() {
    const {
      currentArea,
      agentData,
      printVersion,
      fromEditor,
      version,
      hoData,
      mlsAreas,
      demoAccountHOName,
      quarterlyAreaTable,
      quarterlyCityTable,
      propertyData,
      MQCityDetails,
      isDemo,
      missionStatement,
      coverPageDetails,
      miniTableDetailsDTO,
      showAllEditButtons,
      lastPMAPrintDate,
    } = this.props;

    return (
      <StandardTableAH
        agentData={agentData}
        currentArea={currentArea}
        printVersion={printVersion}
        fromEditor={fromEditor}
        version={version}
        hoData={hoData}
        mlsAreas={mlsAreas}
        demoAccountHOName={demoAccountHOName}
        quarterlyAreaTable={quarterlyAreaTable}
        quarterlyCityTable={quarterlyCityTable}
        propertyData={propertyData}
        MQCityDetails={MQCityDetails}
        isDemo={isDemo}
        missionStatement={missionStatement}
        coverPageDetails={coverPageDetails}
        miniTableDetailsDTO={miniTableDetailsDTO}
        fromThirdPage={true}
        showAllEditButtons={showAllEditButtons}
        lastPMAPrintDate={lastPMAPrintDate}
      />
    );
  }
}

export default ThirdPageComponents;
